import type { SearchModalProps } from '@common/components/SearchModal/SearchModal.types'

import type { ModalPropsParams } from '../search-modal.interface'

export function buildSearchModalProps(params: ModalPropsParams): SearchModalProps {
  return {
    activeFilterChipId: params.activeFilterChipId,
    activeTabId: params.activeTabId,
    emptyState: params.emptyState,
    filterChips: params.filterChips,
    isLoading: params.isLoading,
    onFilterChipChange: params.onFilterChipChange,
    onItemSelect: params.onItemSelect,
    onOpenChange: params.onOpenChange,
    onQueryChange: params.onQueryChange,
    onTabChange: params.onTabChange,
    open: params.open,
    query: params.query,
    sections: [...params.sections],
    tabs: params.tabs,
  }
}
